// extracted by mini-css-extract-plugin
export default {"cls1":"UserListMenu-cls1__e9967bfc13688a6a0ed1","cls2":"UserListMenu-cls2__b15a11e6eec3f3362e97 UserListMenu-cls1__e9967bfc13688a6a0ed1"};